import { DateTime } from 'luxon'
import React from 'react'
import { useSelector } from 'react-redux'

function ListaYear() {
    const dataYear = useSelector((user) => user.gas.consumi);

    return (
        <table className="year">
          <thead>
            <tr className="headerTable">
              <th className="date">Mese</th>
              <th className="priceKwh">
        
                <span>Prezzo</span>
              </th>
             
            </tr>
          </thead>
          <tbody>
          {dataYear !== null ? (
              dataYear.map((d, i) => 
              d.spesa_giorno === 0 ? null : (
                  <tr key={i}>
                      <td className="date">
                          {DateTime.fromISO(d.mese, {locale: 'it'}).toFormat(`MMMM`)}
                      </td>
                      <td className="priceKwh">
                        {parseFloat(d.consumo_mc).toFixed(2).replace(/\./g, ",")}
                      </td>
                  </tr>
              ))
          ) : null} 
          </tbody>
        </table>
    );
}

export default ListaYear
